<div class="flex flex-row items-center pl-6 pr-4 w-full overflow-hidden" [ngStyle]="{ height: headerHeight() + 'px' }">
  @if (showBackButton()) {
    <mi-round-button
      class="flex-shrink-0 flex-grow-0 mr-3"
      size="md"
      icon="mi2-arrow-left"
      (onClick)="buttonClick('back')"
      [tooltip]="'cl_chat.back' | translate"
      [tooltipPosition]="buttonTooltipPlacement() ? buttonTooltipPlacement() : 'top'"
      [ariaLabel]="'cl_chat.back' | translate"
    ></mi-round-button>
  }
  <div
    class="shrink select-none overflow-hidden whitespace-nowrap text-ellipsis"
    [ngStyle]="{ fontSize: fontSize() + 'px' }"
    title="{{ title() }}"
  >
    {{ title() }}
  </div>
  <div class="grow"></div>
  @if (showSearch()) {
    <div class="w-[175px] shrink-0 ml-6 mr-6 overflow-hidden">
      <p-iconfield iconPosition="left" class="w-full">
        <p-inputicon styleClass="mi2-search" />
        <input
          #searchinput
          type="text"
          pInputText
          class="w-full"
          name="search"
          id="search"
          [attr.placeholder]="'cl_chat.search' | translate"
          [attr.aria-label]="'cl_chat.search' | translate"
          [(ngModel)]="searchModel"
          (ngModelChange)="searchTerm$.next(searchModel)"
          (focus)="searchFocused.set(true)"
          (blur)="searchFocused.set(false)"
        />
        @if (searchModel) {
          <i
            mi-action-icon
            iconClass="mi2-close"
            [label]="'cl_chat.clear' | translate"
            (clicked)="searchModel = ''; searchTerm$.next('')"
          ></i>
        }
      </p-iconfield>
    </div>
  }
  <div class="flex flex-row items-center shrink-0 grow-0 gap-[5px]">
    @for (h of buttons(); track h.id) {
      <mi-round-button
        size="md"
        icon="{{ h.icon }}"
        [disabled]="h.disabled"
        (onClick)="buttonClick(h.id)"
        [tooltip]="h.tooltip"
        [tooltipPosition]="buttonTooltipPlacement() ? buttonTooltipPlacement() : 'top'"
        [ariaLabel]="h.tooltip"
      >
      </mi-round-button>
    }
  </div>
</div>
